export function thenable(driver) {
  return new DriverThenable(driver);
}
export class DriverThenable {
  constructor(driver) {
    this.driver = driver;
  }

  postMessage(message) {
    return new Promise((resolve, reject) => {
      this.driver.postMessage(message);
      const dispose = this.driver.addMessageListener(onMessage);

      function onMessage(arrivedMessage) {
        if (arrivedMessage.id === message.id) {
          dispose();

          if ('error' in arrivedMessage) {
            reject(new Error(arrivedMessage.error));
          } else {
            resolve(arrivedMessage);
          }
        }
      }
    });
  }

}